import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NzNotificationService } from "ng-zorro-antd";
import { TITLE } from 'src/app/utils/enum';
import { FormFieldInfo } from '../../../../models/forms-response.models';

@Component({
    selector: 'app-component-textarea',
    templateUrl: './textarea.component.html',
    styleUrls: ['./textarea.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextAreaComponent implements OnInit, AfterContentChecked {
    @Input() formFieldInfo: FormFieldInfo;
    @Input() formGroup: FormGroup;
    @Input() modalTitle:any;
    @Input() formData: any;
    formFieldConfig: any;
    fieldConfig: any;
    name: string;
    maxLength: string = '';
    minLength: string = '';
    hideTitle: boolean;
    isNumeric: boolean = false;
    value: string;
    fieldCode: string;
    tooltip: string;
    fieldDataInfo:any;
    taxCode="";
    formCode="";
    constructor(private nzModalNotification: NzNotificationService, private cdref: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        try {
            this.formFieldConfig = JSON.parse(this.formFieldInfo.formFieldConfig);
            this.fieldConfig = JSON.parse(this.formFieldInfo.fieldConfig);
            this.fieldCode = this.formFieldInfo.fieldCode;
            this.fieldDataInfo=this.formFieldInfo;
            this.hideTitle = (this.formFieldConfig && this.formFieldConfig.hideTitle) ? this.formFieldConfig.hideTitle : false;
            this.name = (this.formFieldConfig && this.formFieldConfig.displayText) ? this.formFieldConfig.displayText : this.formFieldInfo.name;
            if (this.formFieldConfig) {
                this.minLength = this.formFieldConfig.minLength || null;
                this.maxLength = this.formFieldConfig.maxLength || null;
            }
            if (this.fieldConfig) {
                this.minLength = this.fieldConfig.minLength || null;
                this.maxLength = this.fieldConfig.maxLength || null;
                this.isNumeric = (this.fieldConfig.isNumeric && this.fieldConfig.isNumeric) ? this.fieldConfig.isNumeric : false;
            }
            this.formCode=localStorage.getItem('FORM_CODE');
            this.taxCode=localStorage.getItem('TAXCODE'); 
            this.bindingData();
        } catch (error) {
            this.formFieldConfig = JSON.parse('{ "pattern": "" }');
            this.fieldConfig = JSON.parse('{ "keydownPattern": "" }');
        }
    }

    bindingData(){
        if (this.modalTitle == TITLE.ADD_DATA)//This case is: Click icon(+) to open popup
        {
            this.value = (this.formFieldConfig && this.formFieldInfo.defaultValue) ? this.formFieldInfo.defaultValue : '';
        }
        else if (this.modalTitle == TITLE.UPDATE_DATA) { //This case is: Click icon(edit) to open popup
            if (this.formData) {
                let objectData = this.formData;
                const keys = Object.keys(objectData);
                keys.forEach((key) => {
                    if (key == this.formFieldInfo.fieldCode) {
                        let value = objectData[key];
                        this.value = value;
                    }
                });
            }
        }
        else {
            let storageVal = localStorage.getItem("VALUE_" + this.formFieldInfo.formCode +'_'+ this.taxCode + '_'+ this.fieldCode);
            if (storageVal) {
                this.value = storageVal;
            } else if (this.formData && this.formData[this.fieldCode]) {
                this.value = this.formData[this.fieldCode];
            } else {
                this.value = (this.formFieldConfig && this.formFieldInfo.defaultValue) ? this.formFieldInfo.defaultValue : '';
            }
        }
    }


    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    modelChange() {
        localStorage.setItem("VALUE_" + this.formFieldInfo.formCode +'_'+ this.taxCode + '_'+ this.fieldCode, this.value);
    }
}